import React, { createContext, useContext } from 'react';
import { ADMIN_ROLE, OWNER_ROLE } from '../../../utils/Constants';

const PermissionContext = createContext();
export const usePermissionContext = () => useContext(PermissionContext);

export const PermissionProvider = ({ children, permissions, roles }) => {
  const isAllowedTo = (permission) => {
    return (
      permissions.includes(permission) ||
      roles.includes(ADMIN_ROLE) ||
      roles.includes(OWNER_ROLE)
    );
  };
  return (
    <PermissionContext.Provider value={{ isAllowedTo }}>
      {children}
    </PermissionContext.Provider>
  );
};
